/**
 * PostgREST filter helpers.
 *
 * supabase-js `.or()` takes a raw PostgREST `or=` expression, where `,` `.`
 * `(` `)` are syntax. Any user-supplied value interpolated into such an
 * expression must be double-quoted (with `\` and `"` backslash-escaped) or the
 * filter is corrupted / rejected with a 400. See issue #718 (W-17/W-18/W-19).
 */

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when the value is a canonical UUID (e.g. a Postgres uuid column key). */
export function isUuid(value: string): boolean {
  return UUID_REGEX.test(value);
}

/**
 * Quote a value for safe embedding in a PostgREST filter expression.
 * Double-quotes the value and escapes `\` and `"` so PostgREST reserved
 * characters (`,` `(` `)` `.`) inside it are treated as literals.
 */
export function quoteFilterValue(value: string): string {
  return `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
}

/**
 * Build an `or=` expression matching `%term%` (case-insensitive contains)
 * against each of the given columns, with the term safely quoted.
 *
 * Note: SQL LIKE wildcards (`%`, `_`) in the term stay live, matching the
 * previous search semantics.
 */
export function orIlikeContains(columns: string[], term: string): string {
  const pattern = quoteFilterValue(`%${term}%`);
  return columns.map((column) => `${column}.ilike.${pattern}`).join(',');
}
